var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"languages"},[_c('div',{staticClass:"trait"}),_c('btn-flag',{attrs:{"lang":"fr"},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }